import './suchseite.css';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { nummerAnzeige, vergleicheNummer } from '../buecher';
import { loadAlleLieder, subscribeLieder } from '../liederStore';
import { zerlegeNachTreffern } from '../suche';
import { trackEreignis } from '../tracking';

function Suchseite() {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [lieder, setLieder] = useState([]);
  const [geladen, setGeladen] = useState(false);
  const [suchtext, setSuchtext] = useState('');

  // Die Suche läuft erst, wenn kurz nicht getippt wurde - so bleibt das Textfeld flüssig.
  useEffect(() => {
    const timer = setTimeout(() => setSuchtext(text), 300);
    return () => clearTimeout(timer);
  }, [text]);

  useEffect(() => {
    let cancelled = false;
    const laden = () => loadAlleLieder().then((data) => { if (!cancelled) { setLieder(data); setGeladen(true); } }).catch(() => {});
    laden();
    const abmelden = subscribeLieder(laden);
    return () => { cancelled = true; abmelden(); };
  }, []);

  const sortierteLieder = useMemo(() => [...lieder].sort(vergleicheNummer), [lieder]);

  const treffer = useMemo(() => {
    if (!suchtext.trim()) return [];
    const ergebnis = [];
    sortierteLieder.forEach((lied) => {
      (lied.bloecke || []).forEach((block, index) => {
        const teile = zerlegeNachTreffern(block.text, suchtext);
        if (teile.some((teil) => teil.treffer)) ergebnis.push({ lied, block, index, teile });
      });
    });
    return ergebnis;
  }, [sortierteLieder, suchtext]);

  // Suchbegriffe zählen, sobald kurz nichts mehr geändert wurde (auch ob etwas gefunden wurde).
  const trefferAnzahl = treffer.length;
  useEffect(() => {
    const begriff = suchtext.trim();
    if (!geladen || begriff.length < 3 || text !== suchtext) return undefined;
    const timer = setTimeout(() => trackEreignis(trefferAnzahl ? 'suche' : 'suche_leer', begriff.toLowerCase()), 1500);
    return () => clearTimeout(timer);
  }, [suchtext, geladen, trefferAnzahl, text]);

  return (
    <div id='suche_body'>
      <textarea
        className='suche_text'
        rows={3}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder='Beliebigen Text aus einem Lied eingeben ...'
        aria-label='Suchtext'
      />
      {(!geladen || text !== suchtext) && text.trim() && (
        <div className='suche_laden' role='status' aria-label='Suche läuft'><div className='suche_spinner' /></div>
      )}
      {geladen && text === suchtext && text.trim() && <div className='suche_anzahl'>{treffer.length} Treffer</div>}
      {treffer.map(({ lied, block, index, teile }) => (
        <div key={`${lied.id}-${index}`} className='suche_karte' onClick={() => navigate(`/lied/${lied.id}`)}>
          <div className='suche_titel'>{lied.name}</div>
          <div className='suche_buchname'>Jugendlieder Nr. {nummerAnzeige(lied)}</div>
          <div className={`suche_vers${block.block_typ === 'chor' ? ' ist_chor' : ''}`}>
            {teile.map((teil, i) => (teil.treffer ? <b key={i}>{teil.text}</b> : <span key={i}>{teil.text}</span>))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Suchseite;
